import React from "react";
import { Shield, Clock, ChartBar, Cpu } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const features = [{
  title: "Enterprise Security",
  description: "Bank-grade encryption and secure AI protocols ensure your proprietary data remains private and protected.",
  icon: Shield
}, {
  title: "Operational Efficiency",
  description: "Eliminate manual bottlenecks with intelligent workflows that save your team thousands of hours annually.",
  icon: Clock
}, {
  title: "Data-Driven Insights",
  description: "Transform raw information into actionable intelligence with real-time dashboards and predictive reporting.",
  icon: ChartBar
}, {
  title: "Scalable Intelligence",
  description: "Our modular AI architecture grows with your business, adapting to complex enterprise requirements.",
  icon: Cpu
}];
export default function TheDatazenAdvantage() {
  return <section data-section-id="260478" id="advantage" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 font-default text-foreground">
          Why Businesses Choose DataZen
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, i) => <Card key={i} data-index={i} className="bg-card border-border/40 shadow-md hover:border-primary/50 transition-all duration-300 group h-full flex flex-col backdrop-blur-md">
              <CardHeader>
                <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-lg bg-white/5 border border-white/10 backdrop-blur-sm group-hover:animate-bounce">
                  <feature.icon className="h-8 w-8 text-primary" />
                </div>
                <CardTitle className="font-default text-xl text-foreground text-left">{feature.title}</CardTitle>
              </CardHeader>
              <CardContent className="flex-grow">
                <CardDescription className="text-base text-muted-foreground text-left">
                  {feature.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}